/* global globalThis */
import { LogLevel } from "@azure/msal-browser";
const hostUrl = globalThis.location.origin;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: `${
      hostUrl === "http://localhost:3000"
        ? "http://localhost:3000"
        : `${hostUrl}/landing`
    }/auth/callback`,
    postLogoutRedirectUri: "/landing",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        const loggers = {
          [LogLevel.Error]: () => console.error(message),
          [LogLevel.Info]: () => console.info(message),
          [LogLevel.Verbose]: () => console.debug(message),
          [LogLevel.Warning]: () => console.warn(message),
        };
        const log = loggers[level];
        if (log) log();
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"],
};
